export default "assets/frame-7.ee7f7e1e966c50c2.png"